// extracted by mini-css-extract-plugin
export var createdDate = "_o9-1";
export var divider = "_o9-2";
export var headerDivider = "_o9-3";
export var messagesCard = "_o9-0";
export var messagesContainer = "_o9-7";
export var messagesContainerWrapper = "_o9-4";
export var pointerCapturingButtonBoxes = "_o9-a";
export var showLeftPanelButton = "_o9-9";
export var showMoreButton = "_o9-c";
export var showMoreButtonContainer = "_o9-b";
export var summaryTitle = "_o9-6";
export var systemMessageCardWrapper = "_o9-d";
export var topButtons = "_o9-8";
export var withPadding = "_o9-5";